import { ApiPersonType } from '../api-types/person-type.api';
import { PersonType } from '../app-types/person-type.app';

/**
 * Transforms an ApiPersonType object to an app-specific PersonType object.
 * @description This function maps properties of the ApiPersonType to the PersonType interface.
 * It is used to convert data received from the API into a format that the application can work with.
 * @param input ApiPersonType
 * @returns PersonType
 */
export const transformApiPersonTypeToAppPersonType = (input: ApiPersonType) => {
	const output: PersonType = {
		id: input.id,
		name: input.name,
		isInitiator: input.isInitiator,
		initials: input.initials,
	};
	return output;
};

/**
 * Transforms an array of ApiPersonType objects to an array of app-specific
 * PersonType objects.
 * @param input Array of ApiPersonType objects
 * @description Transforms an array of ApiPersonType objects to an array of app-specific PersonType objects.
 * @returns Array of app-specific PersonType objects
 */
export const transformApiPersonTypesToAppPersonTypes = (input: ApiPersonType[]) => {
	const output: PersonType[] = input.map(transformApiPersonTypeToAppPersonType);
	return output;
};
